<template>
    <section class="fin-space-y-4">
        <el-form ref="emailSendingOptions" label-width="140px">
            <el-form-item v-if="emailAction" label="Send Email">
                <el-select class="fin-w-full" v-model="sendEmail" placeholder="Send Email">
                    <el-option label="Yes" :value="true"></el-option>
                    <el-option label="No" :value="false"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item v-if="smsAction && showSms" label="Send SMS">
                <el-select class="fin-w-full" v-model="sendSms" placeholder="Send SMS">
                    <el-option label="Yes" :value="true"></el-option>
                    <el-option label="No" :value="false"></el-option>
                </el-select>
            </el-form-item>

            <el-row v-if="!emailAction" :gutter="10">
                <el-col :span="sendEmail ? 6 : 24">
                    <el-form-item label="Send Email">
                        <el-select class="w-100" v-model="sendEmail" placeholder="Send Email">
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col v-if="sendEmail" :span="18">
                    <el-form-item label="Email Template">
                        <el-select
                            class="fin-w-full"
                            v-model="emailUid"
                            filterable
                            default-first-option
                            placeholder="Select email template">
                            <el-option
                                v-for="template in emailTemplates"
                                :key="template.uid"
                                :label="template.name"
                                :value="template.uid"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if="!smsAction && showSms" :gutter="10">
                <el-col :span="sendSms ? 6 : 24">
                    <el-form-item label="Send SMS">
                        <el-select class="w-100" v-model="sendSms" placeholder="Send SMS">
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col v-if="sendSms" :span="18">
                    <el-form-item label="SMS Template">
                        <el-select
                            class="fin-w-full"
                            v-model="smsUid"
                            filterable
                            default-first-option
                            placeholder="Select sms template">
                            <el-option
                                v-for="template in smsTemplates"
                                :key="template.uid"
                                :label="template.name"
                                :value="template.uid"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="delaySending ? 6 : 24">
                    <el-form-item label="Delay Sending">
                        <el-select class="w-100" v-model="delaySending" placeholder="Delay Sending">
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col v-if="delaySending" :span="18">
                    <el-form-item label="Send At">
                        <el-date-picker
                            class="fin-w-full"
                            v-model="sendAt"
                            type="datetime"
                            placeholder="Select date and time"
                            :picker-options="pickerOptions"
                            :default-time="currentTime">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'EmailSendOptions',
    props: {
        emailAction: {
            type: [String, Number],
            default: null,
            required: false
        },
        smsAction: {
            type: [String, Number],
            default: null,
            required: false
        },
        isApi: {
            required: true,
        },
        showSms: {
            required: false,
            default: false,
            type: [Boolean]
        },
        showEmail: {
            required: false,
            default: true,
            type: [Boolean]
        }
    },
    data() {
        return {
            sendEmail: false,
            sendSms: false,
            delaySending: false,
            emailTemplate: '',
            smsTemplate: '',
            sendAt: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 3600 * 1000 * 24
                },
                shortcuts: [
                    {
                        text: "1 Hour",
                        onClick: (picker) => {
                            let date = this.$moment().add(1, 'hour')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "2 Hours",
                        onClick: (picker) => {
                            let date = this.$moment().add(2, 'hours')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "4 Hours",
                        onClick: (picker) => {
                            let date = this.$moment().add(4, 'hours')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "6 Hours",
                        onClick: (picker) => {
                            let date = this.$moment().add(6, 'hours')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "8 Hours",
                        onClick: (picker) => {
                            let date = this.$moment().add(8, 'hours')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "Tomorrow",
                        onClick: (picker) => {
                            let date = this.$moment().add(1, 'day')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "Next Week",
                        onClick: (picker) => {
                            let date = this.$moment().add(1, 'week')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "Two Weeks",
                        onClick: (picker) => {
                            let date = this.$moment().add(2, 'weeks')
                            picker.$emit("pick", date)
                        },
                    },
                    {
                        text: "Next Month",
                        onClick: (picker) => {
                            let date = this.$moment().add(1, 'month')
                            picker.$emit("pick", date)
                        },
                    },
                ],
            },
            emailTemplates: [],
            smsTemplates: [],
            emailUid: '',
            smsUid: '',
        }
    },
    computed: {
        ...mapGetters({
            getSendEmail: "ticketEmail/getSendEmail"
        }),
        currentTime() {
            return this.$moment().format("HH:mm:ss")
        }
    },
    watch: {
        'sendEmail': {
            handler(val) {
                this.$store.dispatch("ticketEmail/setSendEmail", val)
            },
            immediate: true
        },
        'sendSms': {
            handler(val) {
                this.$store.dispatch("ticketEmail/setSendSms", val)
            },
            immediate: true
        },
        'delaySending': {
            handler(val) {
                this.$store.dispatch("ticketEmail/setDelaySending", val)
            },
            immediate: true
        },
        'sendAt': {
            handler(val) {
                this.$store.dispatch("ticketEmail/setSendAt", val)
            },
            immediate: true
        },
        'emailTemplate': {
            handler(val) {
                // this.$store.dispatch("ticketEmail/setEmailTemplate", val)
            },
            immediate: true
        },
        'smsTemplate': {
            handler(val) {
                // this.$store.dispatch("ticketEmail/setSmsTemplate", val)
            },
            immediate: true
        },
        'emailAction': {
            handler(val) {
                if (val) {
                    this.getTemplates(val)
                }
            },
            immediate: true
        },
        'smsAction': {
            handler(val) {
                if (val) {
                    this.getTemplates(val)
                }
            },
            immediate: true
        },
        'emailUid': {
            handler(val) {
                if (val) {
                    this.getSingleEmailTemplate(val)
                }
            },
            immediate: true
        },
        'smsUid': {
            handler(val) {
                if (val) {
                    this.getSingleSmsTemplate(val)
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.getAllEmailTemplates()
        this.getAllSmsTemplates()
    },
    methods: {
        getTemplates(action = null) {
            this.isApi.post(`/api/get-merged-template`, {
                action: action,
            }).then(res => {
                const {emailTemplate, smsTemplate} = res.data
                this.$store.dispatch("ticketEmail/setEmailTemplate", emailTemplate)
                this.$store.dispatch("ticketEmail/setSmsTemplate", smsTemplate)

                this.$store.dispatch("ticketEmail/setEmailBody", _.get(emailTemplate, 'body'))
                this.$store.dispatch("ticketEmail/setSmsBody", _.get(smsTemplate, 'body'))

                this.$store.dispatch("ticketEmail/setSubject", _.get(emailTemplate, 'subject'))
            }).catch(error => {
                console.log('getTemplates error ', error)
            })
        },
        getSingleEmailTemplate(uuid = null) {
            this.isApi.post(`/api/get-single-email-template`, {
                uuid: uuid
            }).then(res => {
                this.$store.dispatch("ticketEmail/setEmailTemplate", res.data)
                this.$store.dispatch("ticketEmail/setEmailBody", _.get(res.data, 'body'))
                this.$store.dispatch("ticketEmail/setSubject", _.get(res.data, 'subject'))
            }).catch(error => {
                console.log('getSingleEmailTemplate error ', error)
            })
        },
        getSingleSmsTemplate(uuid = null) {
            this.isApi.post(`/api/get-single-sms-template`, {
                uuid: uuid
            }).then(res => {
                this.$store.dispatch("ticketEmail/setSmsTemplate", res.data)
                this.$store.dispatch("ticketEmail/setSmsBody", _.get(res.data, 'body'))
            }).catch(error => {
                console.log('getSingleSmsTemplate error ', error)
            })
        },
        getAllEmailTemplates() {
            this.isApi.get(`/api/email/get-email-templates`).then(res => {
                console.warn('getAllEmailTemplates', res)
                this.emailTemplates = res.data
            }).catch(error => {
                console.log('getAllEmailTemplates error ', error)
            })
        },
        getAllSmsTemplates() {
            this.isApi.get(`/api/email/get-sms-templates`).then(res => {
                console.warn('getAllSmsTemplates', res)
                this.smsTemplates = res.data
            }).catch(error => {
                console.log('getAllSmsTemplates error ', error)
            })
        }
    }
}
</script>
